module.exports = __webpack_public_path__ + "static/media/chef.012f81dc.svg";